import { cloneDeep } from 'lodash'

export default () => {
  const MATCH_TYPE = {
    eq: '等于',
    neq: '不等于',
    gt: '大于',
    gte: '大于等于',
    lt: '小于',
    lte: '小于等于',
    in: '包含',
    notin: '不包含'
  }

  const hasNumberValidation = (componentReg) => {
    if (!componentReg) return false
    const regEntity = JSON.parse(componentReg)

    return regEntity.validationType && regEntity.validationType.includes('number')
  }

  // 解析定向匹配条件
  const parseBusinessMatchType = (spaceComponent, businessEntity) => {
    if (businessEntity) return businessEntity.componentMatchType
    // 设置默认的matchType
    switch (spaceComponent.componentType) {
      case 'checkbox':
      case 'range':
        if (spaceComponent.componentKey === 'cBrand' || spaceComponent.componentMatchType === 'notin') return 'notin'
        return 'in'
      case 'text':
        return hasNumberValidation(spaceComponent.componentReg)
          ? (spaceComponent.componentMatchType ? spaceComponent.componentMatchType : 'eq')
          : 'in'
      default:
        return spaceComponent.componentMatchType ? spaceComponent.componentMatchType : 'eq'
    }
  }

  // 解析定向匹配值
  const parseBusinessValue = (spaceComponent, businessEntity, isSetDefault) => {
    if (businessEntity) {
      return spaceComponent.componentType !== 'checkbox'
        ? businessEntity.componentValue
        : (businessEntity.componentValue ? businessEntity.componentValue.split(',') : [])
    }
    if (spaceComponent.componentType !== 'checkbox') {
      return isSetDefault ? spaceComponent.componentDefaultValue : ''
    } else {
      return isSetDefault
        ? (spaceComponent.componentDefaultValue ? spaceComponent.componentDefaultValue.split(',') : [])
        : []
    }
  }

  // 构建组件值请求参数
  const buildBusinessValue = (spaceComponent) => {
    switch (spaceComponent.componentType) {
      case 'checkbox':
        return spaceComponent.componentValue ? spaceComponent.componentValue.join(',') : ''
      case 'range':
        return JSON.stringify([spaceComponent.minValue, spaceComponent.maxValue])
      default:
        return spaceComponent.componentValue
    }
  }

  // 设置定向 spaceComponents：广告位默认定向 businessList：编辑过的定向 isSetDefault: 是否设置组件默认值
  const setBusinessComponents = (spaceComponents, businessList = [], isSetDefault) => {
    const businessCollect = cloneDeep(businessList).reduce((result, cur) => {
      result[cur.componentId] = cur
      return result
    }, {})

    return spaceComponents.map(item => {
      let businessEntity = businessCollect[item.componentId]

      const resItem = {
        componentId: item.componentId,
        componentName: item.componentName,
        componentKey: item.componentKey,
        componentMatchType: parseBusinessMatchType(item, businessEntity),
        componentType: item.componentType,
        componentReg: item.componentReg ? JSON.parse(item.componentReg) : '',
        componentValue: parseBusinessValue(item, businessEntity, isSetDefault),
        checkValue: item.componentDefaultValue,
        componentPlace: item.componentPlace,
        option: JSON.parse(item.componentValue || '[]').map(item => {
          return {
            label: item.value,
            value: item.key
          }
        })
      }
      if (resItem.componentType === 'range') {
        resItem.minValue = JSON.parse(resItem.componentValue)[0]
        resItem.maxValue = JSON.parse(resItem.componentValue)[1]
      }
      return resItem
    })
  }

  // 根据component获取条件名称
  const getMatchTypeName = (entity) => {
    if (!entity.componentMatchType) {
      entity.componentMatchType = parseBusinessMatchType(entity)
    }
    if (entity.componentType === 'range' && entity.componentMatchType === 'in') {
      return '介于'
    }
    return MATCH_TYPE[entity.componentMatchType]
  }

  // 获取值名称
  const getComponentValueName = (spaceComponent, entity) => {
    if (entity.componentType === 'text') {
      return entity.componentValue
    } else if (entity.componentType === 'range') {
      const values = JSON.parse(entity.componentValue)
      return `${values[0]}~${values[1]}`
    }
    const valueArr = entity.componentValue.split(',')
    const optionEnum = JSON.parse(spaceComponent.componentValue || []).reduce((result, cur) => {
      result[cur.key] = cur.value
      return result
    }, {})
    return valueArr.map(item => optionEnum[item]).filter(item => item).join('、')
  }

  // 获取详情
  const getComponentsDetail = (spaceComponents = [], businessList = []) => {
    const spaceCollect = cloneDeep(spaceComponents).reduce((result, cur) => {
      result[cur.componentId] = cur
      return result
    }, {})

    return businessList.map(item => {
      let spaceComponent = spaceCollect[item.componentId]

      return {
        componentKey: item.componentKey,
        componentName: spaceComponent.componentName,
        componentMatchTypeName: getMatchTypeName(item),
        componentValue: getComponentValueName(spaceComponent, item)
      }
    })
  }

  return {
    setBusinessComponents,
    buildBusinessValue,
    getComponentsDetail
  }
}
